import * as Website from '../../../Config/Website.js';
const init = () => {
  check();
}

const check = () => {
  const targetElm = document.getElementById('js-cv');
  if (!targetElm) return;
  const threshold = Website.status.page.toLowerCase() === 'home' ? Website.status.winHeight : 100;
  if(Website.status.scrollY > threshold) {
    targetElm.classList.add(Website.classList.actView);
  } else {
    targetElm.classList.remove(Website.classList.actView);
  }
} 

export {
  init, 
  check
}
